import { LicenseType } from '@ebalance/proto/bfftypes/v1/license_type_pb'

/**
 * 需要調達計画の種別 (2値)。procurement-plan-list-type-filter 設計書 §4/§5
 * (spec AC-019/AC-020) 準拠。SelfWheeling (自己託送 BG) は小売電気事業者では
 * ないため「BG」側、Retail (小売) は「小売」側に写す。
 */
export type PlanType = 'bg' | 'retail'

/**
 * BG コードから需要調達計画の種別を判定する純関数
 * (procurement-plan-list-type-filter 設計書 §5)。
 *
 * 需要調達計画の BG は Retail(2) または SelfWheeling(5) のみという backend
 * 不変条件 (demand_procurement_master.go:253-254) に基づき判定する。
 * bgMasterMap に該当 bgCode が無い場合、または上記 2 値以外の licenseType の
 * 場合は種別不明として undefined を返す (AC-05: BG マスタが削除された計画は
 * 「すべて」では表示しつつ「BG」「小売」では非表示にするための判定材料)。
 */
export function classifyPlanType(
  bgCode: string,
  bgMasterMap: Map<string, LicenseType>,
): PlanType | undefined {
  switch (bgMasterMap.get(bgCode)) {
    case LicenseType.RETAIL:
      return 'retail'
    case LicenseType.SELF_WHEELING:
      return 'bg'
    default:
      return undefined
  }
}
